<template>
    <div class="top">
        <div style="max-width:420px;margin:auto;"><img src="@/assets/topImage.png"></div>
        <h1 class="title is-4">エモーションダイアリーとは？</h1>
            <div class="text_area">
                <p>エモーションダイアリーは、日記やモーニングページをパソコンで執筆、管理できるサービスです。</p>
                <p>月ごとに日記を書いた日付と文字数が一覧で把握できます。また、AIによるテキスト分析であなたの書いた文章全体のポジティブ度や感情の振れ幅を客観的に把握するお手伝いをします。</p>
            </div>
        <h2 class="title is-4">オンラインのプライベート日記</h2>
            <div class="columns">
                <div class="column">
                    <p>データはオンラインで保存するため、どのパソコン、スマートフォンからでもアクセスして日記を書くことができます。</p>
                    <p>また、エモーションダイアリーは、日記もモーニングページも「自分にために書く」ことが大切だと考えています。そのため文章のシェア機能や共有機能は一切ありません。自分のために、心のままに書いてください。</p>
                </div>
                <div class="column">
                    <img src="@/assets/topImage_pc.jpg">
                </div>
            </div>
        <h2 class="title is-4">エモーションダイアリーを作った経緯</h2>
            <div class="text_area">
                <p>エモーションダイアリーは、私が日々の習慣としている「モーニングページ」のために作りました。
                <p>モーニングページは、ジュリアキャメロン著「ずっとやりたかったことを、やりなさい」で紹介されている創造性を伸ばす方法で、毎朝起きたらすぐにノート３ページに自分の心に浮かぶまま文章を書く作業のことを言います。</p>
                <p>モーニングページをやると、普段のごちゃごちゃした気持ちが整理され、自分の心に素直になれ思考がスッキリします。脳のデトックス作業です。</p>
                <p>「ずっとやりたかったことを、やりなさい」では、モーニングページは紙のノートで書くと良いとされていますが、私はパソコンで書いた方が無理なく続けられたため、途中からパソコンを使うようになりました。</p>
                <p>このエモーションダイアリーでは、私がモーニングページを書く中で欲しいと思った機能をつけています。例えば、書いているページで自分が現在何文字書いたかわかる文字数のカウント機能や、モーニングページを客観的に把握できるように、書いた日と書いた日数がわかるページ、さらにAIによるテキスト分析で感情の変化などがわかるページを作りました。</p>
                <p>そして、ダイアリーという名前の通り、日々の日記としても使うことができます。</p>
            </div>
        <h2 class="title is-4">こんな場合におすすめ</h2>
        <div class="columns">
            <div class="column">
                <h3 class="title is-5" style="text-align:center;">モーニングページに</h3>
                <p>朝起きてすぐに思いつくままに言葉を書くモーニングページは、自分の創造性を伸ばすのに最適なワークアウトです。</p>
                <p>モーニングページが推奨するノート３ページ分は、日本語だと大体1200文字が目安です。</p>
            </div>
            <div class="column">
            <img src="@/assets/morning_page.jpg">
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <img src="@/assets/diary_image.jpg">
            </div>
            <div class="column">
            <h3 class="title is-5" style="text-align:center;">日記・日々の記録に。自分の感情の把握に</h3>
                <p>今日起きた出来事や感じたことをまとめる日記は、自分の気持ちを整理する良いエクササイズです。</p>
                <p>書いた日記はデータとして残るので、アーカイブとして管理ができます。</p>
                <p>日毎にテキストの感情をスコア化し、誰にも見せることなく客観的に自分の感情を把握できます。</p>
            </div>
        </div>
        <h2 class="title is-4">データで日記を客観的に把握</h2>
            <div class="text_area">
                <p>パソコンで文章を書くメリットは、文章を書く手助けとなる様々なデータがわかることです。</p>
                <p>エモーションダイアリーでは、現在以下のデータが簡単に把握できます。</p>
                <p>・文字数</p>
                <p>・当月に日記を書いた日数や日付</p>
                <p>・文章のポジティブ度</p>
            </div>
        <h2 class="title is-4">テキスト分析により文章に含まれる感情を分析します</h2>
            <div class="text_area">
                <p>エモーションダイアリーは、文章・言葉そのものが持つ力を大切にします。</p>
                <p>明るい気持ちの時にはポジティブな言葉が、落ち込んでいる時にはネガティブな言葉が日記に増えるのは当然でしょう。また、気持ちが揺らいでる時にはネガティブとポジティブの言葉が入り混じるはずです。</p>
                <p>この感情を客観的に把握できるよう、エモーションダイアリーでは、Googleが提供するテキスト分析ツール「Google Natural Language API」を利用し、文章のポジティブ度を計測します。</p>
                <p>AI（機械学習)による分析であるため、人間とは違った観点から客観的に感情を把握する助けになるはずです。</p>
                <div class="columns">
                    <div class="column">
                        <img src="@/assets/top_image_pie.png" alt="">
                    </div>
                    <div class="column">
                        <img src="@/assets/top_image_score.png" alt="">
                        <img src="@/assets/top_image_sentiment.png" alt="">
                    </div>
                </div>
            </div>
        <h2 class="title is-4">料金</h2>
            <div class="text_area">
                <p>初月はお試し期間で無料です。その後は月額500円がかかります。代金はクレジットカードでお支払いいただきます。</p>
            </div>
        <div v-if="!userStatus" style="text-align:center;font-size:1.2em;padding-top:30px;"><router-link to="login"><i class="fas fa-sign-in-alt"></i> 登録して始める！</router-link></div>
    </div>
</template>

<script>
export default {
    computed: {
        userStatus() {
            return this.$store.getters.isSignIn;
        }
    },
    mounted(){
        const title = "エモーションダイアリーとは？｜エモーションダイアリー"
        const description = "エモーションダイアリーの概要の説明です。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    }   
}
</script>

<style scoped>
.top{
    max-width:900px;
    margin: auto;
    padding:20px;
}
.title{
    margin:40px 0px 20px 0px;
}

</style>